import React from "react";
import {Icon} from "antd";
import {Link} from "react-router-dom";

import i18n from "../../../i18n";

export default function GuestInstructionAccessGate({
                                                       locked,
                                                       children,
                                                   }) {
    if (!locked) {
        return <>{children}</>;
    }

    return (
        <div className="guest-instruction-gate">
            <div
                className="guest-instruction-gate__preview"
                aria-hidden="true"
            >
                {children}
            </div>

            <div className="guest-instruction-gate__overlay">
                <div
                    className="guest-instruction-gate__card"
                    role="region"
                    aria-label={i18n.t(
                        "servicePage.guestAccess.title"
                    )}
                >
                    <span className="guest-instruction-gate__icon">
                        <Icon type="lock"/>
                    </span>

                    <h2>
                        {i18n.t(
                            "servicePage.guestAccess.title"
                        )}
                    </h2>

                    <p>
                        {i18n.t(
                            "servicePage.guestAccess.description"
                        )}
                    </p>

                    <div className="guest-instruction-gate__actions">
                        <Link
                            className="guest-instruction-gate__login"
                            to="/login"
                        >
                            {i18n.t(
                                "servicePage.guestAccess.login"
                            )}
                        </Link>

                        <Link
                            className="guest-instruction-gate__register"
                            to="/register"
                        >
                            {i18n.t(
                                "servicePage.guestAccess.register"
                            )}
                        </Link>
                    </div>

                    <Link
                        className="guest-instruction-gate__catalog"
                        to="/service/instruction"
                    >
                        <Icon type="download"/>

                        <span>
                            {i18n.t(
                                "servicePage.guestAccess.catalog"
                            )}
                        </span>
                    </Link>
                </div>
            </div>
        </div>
    );
}
